import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { FundDocument } from '../types';

export const useUpdateFundDocument = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: FundDocument },
    Error,
    { fundId: string; document: Partial<FundDocument> & { id: string } }
  >({
    mutationFn: ({ fundId, document }) =>
      api.put<FundDocument>(`funds/${fundId}/files/${document.id}`, document),
    onSuccess: (_data, { fundId }) => {
      queryClient.invalidateQueries({ queryKey: ['funds', fundId, 'files'] });
    },
  });

  const updateFundDocument = async (
    fundId: string,
    document: Partial<FundDocument> & { id: string },
  ) => {
    await mutateAsync({ fundId, document });
  };

  return {
    updateFundDocument,
    isLoading,
  };
};
